import { AppsManagementServiceClient } from '@playq/octopus2-apps';

import { transport } from '../core';

export const appsService = new AppsManagementServiceClient(transport);
